export default __webpack_public_path__ + "static/media/what_to_do_on_a_yacht.6b78cede.webp";